<template>
  <!-- Steps Progress -->
  <section class="s-strip s-strip--short s-strip--theme-grey">
    <div class="page-container">
      <div class="s-strip__header mb-40">
        <div class="b-strip-header align-items-center">
          <div class="title h2">{{ dictionary.step3Label }}</div>
        </div>
      </div>
      <div class="b-booking-wizard mb-40">
        <div class="b-booking-wizard__steps">
          <ul>
            <li class="is-previous">
              <div class="bar">
                <div class="progress is-active"></div>
              </div>

              <button type="button">
                <i class="icon-check"></i>
              </button>
              <em>{{ step1 }}</em>
            </li>
            <li class="is-previous">
              <div class="bar">
                <div class="progress"></div>
              </div>
              <button type="button">
                <i class="icon-check"></i>
              </button>
              <em>{{ step2 }}</em>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="s-strip d-print-none page-container">
    <!-- Warning -->
    <div class="alert alert-warning alert-dismissible mb-40" role="alert">
      <div class="alert__body">
        <div class="alert__aside d-none d-lg-flex">
          <LazyImage :image="{ url: '/imgs/icons/alert-warning.svg' }" />
        </div>
        <div class="alert__main" v-html="dictionary.alertWarningText"></div>
      </div>
      <button
        type="button"
        class="btn btn-clear btn-close"
        data-bs-dismiss="alert"
        aria-label="Close">
        <i class="icon-close-light"></i>
      </button>
    </div>

    <div class="row b-personal-info mb-40 flex-column-reverse flex-xl-row">
      <!-- Personal info -->
      <div class="col-xl-8 col-lg-12">
        <!-- Personal info label -->
        <div class="row d-none d-lg-flex">
          <div class="col mb-30 fs-20">
            <span class="h2 semibold">
              {{ dictionary.resumePersonalDataLabel }}
            </span>
          </div>
        </div>
        <!-- Personal info tables -->
        <div class="b-personal-info__conts mb-40">
          <dl>
            <dt>{{ dictionary.resumeNameLabel }}</dt>
            <dd>{{ name }}</dd>
          </dl>
          <dl>
            <dt>{{ dictionary.resumeEmailLabel }}</dt>
            <dd>
              <a :href="'mailto:' + email">{{ email }}</a>
            </dd>
          </dl>
          <dl>
            <dt>{{ dictionary.resumePhoneLabel }}</dt>
            <dd>
              <a :href="'tel:' + phone">{{ phone }}</a>
            </dd>
          </dl>
        </div>
        <ul class="b-qr-buttons-list mb-40">
          <li>
            <button
              type="button"
              class="btn btn-primary btn-full-width"
              @click="onNewForm">
              {{ dictionary.newRequestButtonText }}
            </button>
          </li>
          <li>
            <Anchor
              v-if="returnToHomeLink"
              :item="returnToHomeLink"
              class="btn btn-outline-primary btn-full-width"></Anchor>
          </li>
        </ul>
      </div>
      <!-- Vehicle resume -->
      <div class="col-xl-4">
        <div v-for="(item, index) in vehiclesData" :key="index" class="mb-32">
          <VehicleResume
            :vehicle="item"
            :panel-number="index"
            :editable="false" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import * as lib from '../../../lib/lib'
import LazyImage from '../../components/common/LazyImage.vue'
import VehicleResume from './VehicleResume.vue'
import Anchor from './../common/Anchor.vue'

export default {
  components: {
    Anchor,
    LazyImage,
    VehicleResume,
  },
  props: {
    step: {
      required: true,
      type: Number,
    },
    vehiclesData: {
      required: true,
      type: Array,
    },
    customerData: {
      required: true,
      type: Object,
    },
  },
  emits: ['get-step'],
  data() {
    return {
      name: '',
      email: '',
      phone: '',

      steps: [],
      returnToHomeLink: null,
    }
  },
  computed: {
    gotoStart() {
      return 1
    },
    step1() {
      return this.steps[0] ? this.steps[0].summary : ''
    },
    step2() {
      return this.steps[1] ? this.steps[1].summary : ''
    },
  },
  mounted() {
    const { steps, returnToHomeLink } = lib.getData('quotationData')

    this.steps = steps
    this.returnToHomeLink = returnToHomeLink

    this.name = `${this.customerData.Name}  ${this.customerData.Surname}`
    this.email = this.customerData.Email
    this.phone = `${this.customerData.DialingCode}${this.customerData.Phone}`

    lib.appendUrlParam('page', 'success')

    this.$nextTick(() => {
      lib.scrollToTop()
    })
  },
  methods: {
    onNewForm() {
      this.$emit('get-step', this.gotoStart, true)
    },
  },
}
</script>
